<template>
  <div
    v-if="items.length > 0"
    class="dual-vendible-selector"
  >
    <v-row
      :class="showRemove ? 'mt-2' : 'ma-4'"
      class="justify-center"
    >
      <v-col
        v-if="showRemove"
        cols="1"
        class="text-center"
      >
        <v-btn
          icon
          :color="pairContainer._destroy ? 'error' : 'default'"
          small
          class="mt-1"
          :disabled="disabled"
          @click="handleRemove"
        >
          <v-icon small>
            {{ icons.mdiClose }}
          </v-icon>
        </v-btn>
      </v-col>
      <v-col :cols="5">
        <v-select
          v-model="selectedFromItem"
          :items="items"
          item-text="attributes.name"
          item-value="id"
          :label="fromLabel"
          outlined
          dense
          return-object
          :disabled="disabled"
        >
          <template #selection="{ item }">
            <span>{{ item.attributes.name }}</span>
          </template>
          <template #item="{ item }">
            <div>
              <div>{{ item.attributes.name }}</div>
            </div>
          </template>
        </v-select>
      </v-col>

      <v-col
        cols="1"
        class="text-center mt-2"
      >
        <v-icon
          medium
          color="primary"
        >
          {{ icons.mdiArrowRight }}
        </v-icon>
      </v-col>

      <v-col :cols="5">
        <v-select
          v-model="selectedToItem"
          :items="items"
          item-text="attributes.name"
          item-value="id"
          :label="toLabel"
          outlined
          dense
          return-object
          :disabled="disabled"
        >
          <template #selection="{ item }">
            <span>{{ item.attributes.name }}</span>
          </template>
          <template #item="{ item }">
            <div>
              <div>{{ item.attributes.name }}</div>
            </div>
          </template>
        </v-select>
      </v-col>
    </v-row>
  </div>
  <v-alert
    v-else
    type="info"
    outlined
    class="text-caption"
  >
    {{ emptyMessage }}
  </v-alert>
</template>

<script>
import { ref, computed } from '@vue/composition-api'
import { mdiPlus, mdiArrowRight, mdiClose } from '@mdi/js'

export default {
  props: {
    pairContainer: {
      type: Object,
      default: () => ({}),
    },
    items: {
      type: Array,
      default: () => [],
    },
    fromLabel: {
      type: String,
      default: '変更元',
    },
    toLabel: {
      type: String,
      default: '変更先',
    },
    addButtonText: {
      type: String,
      default: '追加',
    },
    emptyMessage: {
      type: String,
      default: 'アイテムがありません',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    showRemove: {
      type: Boolean,
      default: false,
    },
    fromValue: {
      type: Object,
      default: null,
    },
    toValue: {
      type: Object,
      default: null,
    },
  },
  setup(props, { emit }) {
    const selectedFromItem = computed({
      get: () => props.fromValue,
      set: value => emit('update:from-value', value),
    })

    const selectedToItem = computed({
      get: () => props.toValue,
      set: value => emit('update:to-value', value),
    })

    const canAdd = computed(() => {
      return selectedFromItem.value && selectedToItem.value
              && selectedFromItem.value.id !== selectedToItem.value.id
    })

    const handleAdd = () => {
      if (!canAdd.value) return

      emit('add', {
        from: selectedFromItem.value,
        to: selectedToItem.value,
      })

      emit('update:from-value', null)
      emit('update:to-value', null)
    }

    const handleRemove = () => {
      emit('remove')
    }

    return {
      selectedFromItem,
      selectedToItem,
      canAdd,
      handleAdd,
      handleRemove,
      icons: {
        mdiPlus,
        mdiArrowRight,
        mdiClose,
      },
    }
  },
}
</script>
